export default "__VITE_ASSET__BWM39YAS__"